import { createSlice } from "@reduxjs/toolkit";

export const guideSlice = createSlice({
  name: "guide",
  initialState: {
    filteredGuide: [],
    activeGuide: {},
    isGuidePanel: false,
    lastGuideSearchCriteria: undefined,
  },
  reducers: {
    setIsGuidePanel: (state, action) => {
      state.isGuidePanel = action.payload;
    },
    setFilteredGuide: (state, action) => {
      state.filteredGuide = action.payload;
    },
    setCurrentGuide: (state, action) => {
      state.activeGuide = action.payload;
    },
    setLastGuideSearchCriteria: (state, action) => {
      state.lastGuideSearchCriteria = action.payload;
    },
  },
  selectors: {
    getFilteredGuide: (state) => state.filteredGuide,
    getActiveGuide: (state) => state.activeGuide,
    getIsGuidePanel: (state) => state.isGuidePanel,
    getLastGuideSearchCriteria: (state) => state.lastGuideSearchCriteria,
  },
});

export const { setIsGuidePanel, setFilteredGuide, setCurrentGuide, setLastGuideSearchCriteria } =
  guideSlice.actions;
export const { getIsGuidePanel, getFilteredGuide, getActiveGuide, getLastGuideSearchCriteria } =
  guideSlice.selectors;
